'use client'

import React from 'react'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { RecruitItem } from '@/types/recruit'
import cardStyles from '@/components/Shared/Card/styles.module.scss'
import styles from './styles.module.scss'

interface RecruitCardProps {
  recruit: RecruitItem
  used?: string
  articleTitle?: string
}

export default function RecruitCard({ recruit, used, articleTitle }: RecruitCardProps) {
  const pathname = usePathname()
  const cardClass =
    used && styles[used]
      ? `${cardStyles.cardBase} ${styles.card} ${styles[used]}`
      : `${cardStyles.cardBase} ${styles.card}`

  // previewページ判定
  const isPreviewPath = /^\/preview\//.test(pathname || '')

  const handleRecruitClick = () => {
    // previewページの場合はスキップ
    if (isPreviewPath) return

    setTimeout(() => {
      if (typeof window !== 'undefined' && (window as any).krt && pathname) {
        const isCompanyPage = pathname.includes('/recruitments')
        const title = isCompanyPage ? '採用情報一覧' : articleTitle || ''

        ;(window as any).krt('send', 'click_recruit_info', {
          title,
          name: recruit.title,
          url: window.location.href,
          link: recruit.url,
        })
      }
    }, 0)
  }

  return (
    <article className={cardClass}>
      <Link
        className={styles.cardLink}
        href={recruit.url}
        target='_blank'
        rel='noopener noreferrer'
        onClick={handleRecruitClick}
      />
      <div className={styles.cardContentsContainer}>
        <div className={styles.cardImg}>
          <img
            src={recruit.thumbnail || '/images/svg/hide_image.svg'}
            width={800}
            height={450}
            className={styles.eyecatchImage}
            alt={recruit.title}
            loading='lazy'
          />
        </div>
        <div className={styles.cardContents}>
          <div className={styles.cardInformation}>
            <span className={styles.recruitmentType}>{recruit.recruitmentType}</span>
          </div>
          <div className={styles.contentsBody}>
            <div className={styles.recruitTitle}>{recruit.title}</div>
            {recruit.description && (
              <p className={styles.recruitDescription}>{recruit.description}</p>
            )}
          </div>
        </div>
      </div>
    </article>
  )
}
